import { connect } from 'react-redux';
import { getRegistries } from 'actions/website/entities/RegistryActions';

import experimentFlags, { WEBSITE_TO_REGISTRY } from '../../../../../util/experimentFlags';

import RegistryContainer from './RegistryContainer';

const mapStateToProps = state => {
  const hasZolaRegistry = state.user.userContext.registry_ids.length > 0;
  const hasExternalRegistry = state.website.entities.orderedIds.length > 0;
  const inWebToRegExperiment = experimentFlags.isUnderTest(
    WEBSITE_TO_REGISTRY,
    state.user.userContext
  );
  return {
    hasRegistry: hasZolaRegistry || hasExternalRegistry,
    inWebToRegExperiment,
  };
};

const mapDispatchToProps = dispatch => ({
  getRegistryEntities: callback => {
    dispatch(getRegistries()).then(callback());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(RegistryContainer);
